import { memo } from "react";

import TableHead from "ds/components/Table/Head";
import { getColumnKey } from "ds/components/Table/Head/Column/utils";
import { TableColumnMeta } from "ds/components/Table/types";
import { TableColumnsState } from "ds/components/Table/useTableStore/types";

import { useIdpGroupTableStore } from "../useIdpGroupTableStore";
import { selectVisibleColumns } from "../useIdpGroupTableStore/selectors";
import IdpGroupTableHeadColumn from "./Column";
import { IDP_GROUP_COLUMN_ID } from "../../constants";

type IdpGroupTableState = TableColumnsState<IDP_GROUP_COLUMN_ID>;

const IdpGroupTableHead = () => {
  const columns = useIdpGroupTableStore((state: IdpGroupTableState) => selectVisibleColumns(state));

  return (
    <TableHead>
      {columns.map((column: TableColumnMeta<IDP_GROUP_COLUMN_ID>) => (
        <IdpGroupTableHeadColumn key={getColumnKey(column)} column={column} />
      ))}
    </TableHead>
  );
};

export default memo(IdpGroupTableHead);
